<template>
  <div :class="contentWidth === 'boxed' ? 'container p-0' : null">
    <Spinner />
    <router-view />
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig';
import Spinner from '../../components/spinner/Index.vue';

export default {
  components: {
    Spinner,
  },
  setup() {
    const { contentWidth } = useAppConfig();
    return { contentWidth };
  },
};
</script>
